import controller from './responsive.controller';
import template from './responsive.html';
import './responsive.css';

const HealthcarebookResponsiveComponent = {
    bindings: {
    },
    controller,
    template,
};

export default HealthcarebookResponsiveComponent;


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/responsive/responsive.component.js
// module id = 631
// module chunks = 0